import { useCallback } from 'react';
import type { GoodsCoreModel, IScreensLogging } from '../../../../../api/types';
import { bridge, isNotNil } from '../../../../../utils';
import { AdAction } from '../../../../../utils/eventLogger/adLogger/types';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';

type LogOnPressLikeParams = {
  item: GoodsCoreModel;
  logging: IScreensLogging;
  currentLike: boolean;
};

export const useLogOnPressLike = () => {
  const screen = useAtomicScreen();

  return useCallback(
    ({ item, logging, currentLike }: LogOnPressLikeParams) => {
      const name = currentLike ? 'CLICK_UNLIKE_GOODS' : 'CLICK_LIKE_GOODS';

      bridge.logAnalyticsEvent({
        name,
        analytics: {
          ...logging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: logging.ably_only_log,
      });

      if (isNotNil(item.ad)) {
        bridge.logAdEvent({
          action: currentLike ? AdAction.UNLIKE : AdAction.LIKE,
          ad: item.ad,
        });
      }
    },
    [screen],
  );
};
